import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { Product } from '@shared/models/product.model';

@Component({
  selector: 'app-ai-list-ingredient-menu-product-card',
  templateUrl: './ai-list-ingredient-menu-product-card.component.html',
  styleUrls: ['./ai-list-ingredient-menu-product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiListIngredientMenuProductCardComponent {
  @Input() product: Product;
  @Input() loading = false;
  @Input() selected = false;

  @Output() productClicked: EventEmitter<Product> = new EventEmitter();
  @Output() selectionChanged: EventEmitter<Product> = new EventEmitter();

  constructor() {}

  onProductClick() {
    this.productClicked.emit(this.product);
  }

  onSelectionChange() {
    this.selectionChanged.emit(this.product);
  }
}
